// i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { filters } from "../common/filters.js";

import zh from './zh';
import en from './en';
import ja from './ja';
import tw from './tw';
import ko from './ko';
import ru from './ru';
import th from './th';
import fr from './fr';
import es from './es';
import de from './de';
import it from './it';

Vue.use(VueI18n);
const defaultLocale = localStorage.getItem('lang')  || filters.getLocale();
console.log(defaultLocale)
const i18n = new VueI18n({
	locale: defaultLocale, // 默认语言
	messages: {
		'en': en,
		'zh': zh,
		'ja': ja,
		'tw': tw,
		'ko': ko,
		'ru': ru,
		'th': th,
		'fr': fr,
		'es': es,
		'de': de,
		'it': it,
	},
});

export default i18n;